// src/components/Footer.jsx
import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6">
            <div>{currentYear} © Bagra Mangement</div>
          </div>
          <div className="col-md-6">
            <div className="d-none d-md-flex gap-4 align-items-center justify-content-md-end">
             
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
